import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Mail, Phone, Facebook, Twitter, Instagram, Youtube } from "lucide-react";

const R = "/gb/en";

const support = [
  { t: "Book an Appointment", to: `${R}/appointment.html` },
  { t: "Contact Us", to: `${R}/contact-us.html` },
  { t: "Customer Support", to: `${R}/contact-us.html` },
  { t: "FAQs", to: `${R}/faq.html` },
  { t: "Pet Emergency Help", to: `${R}/contact-us.html` },
];

const useful = [
  { t: "About Moggies & Doggies", to: `${R}/about-us.html` },
  { t: "Our Services", to: `${R}/services.html` },
  { t: "Pet Wellness Blog", to: `${R}/blog.html` },
  { t: "Meet Our Vets", to: `${R}/our-team.html` },
];

const Footer = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    setDone(true);
    setName("");
    setEmail("");
    setTimeout(() => setDone(false), 3500);
  };

  return (
    <footer className="bg-pawelle-footer text-white">
      <div className="mx-auto max-w-[1290px] px-5 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          {/* Newsletter */}
          <div>
            <h3 className="max-w-xs font-display text-[22px] font-semibold leading-snug text-white">
              Subscribe for expert insights and exclusive pet wellness updates.
            </h3>
            <form onSubmit={submit} className="mt-6 flex max-w-md flex-col gap-3">
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
                className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 font-body text-sm text-white placeholder-white/50 outline-none transition focus:border-pawelle-primary"
              />
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Email"
                className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 font-body text-sm text-white placeholder-white/50 outline-none transition focus:border-pawelle-primary"
              />
              <button
                type="submit"
                className="mt-1 rounded-xl bg-pawelle-primary px-6 py-3 font-display text-[15px] font-medium text-white transition-all duration-300 hover:bg-pawelle-primary-dark"
              >
                {done ? "Subscribed!" : "Join the Newsletter"}
              </button>
            </form>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white">Support</h4>
            <ul className="mt-5 space-y-3">
              {support.map((l) => (
                <li key={l.t}>
                  <Link to={l.to} className="group flex items-center gap-2 font-body text-[15px] text-white/70 transition-colors hover:text-white">
                    <CheckCircle2 className="h-4 w-4 text-pawelle-primary" />
                    {l.t}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Useful Links */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white">Useful Links</h4>
            <ul className="mt-5 space-y-3">
              {useful.map((l) => (
                <li key={l.t}>
                  <Link to={l.to} className="group flex items-center gap-2 font-body text-[15px] text-white/70 transition-colors hover:text-white">
                    <CheckCircle2 className="h-4 w-4 text-pawelle-primary" />
                    {l.t}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Clinic */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white">Our Clinic</h4>
            <div className="mt-5 space-y-4 font-body text-[15px] text-white/70">
              <p>
                Swadlincote
                <br />
                DE11
              </p>
              <p className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-pawelle-primary" />
                info@moggiesanddoggiesvets.com
              </p>
              <p className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-pawelle-primary" />
                07535 341283
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-dashed border-white/15">
        <div className="mx-auto flex max-w-[1290px] flex-col items-center gap-5 px-5 py-6 md:flex-row md:justify-between">
          <img src="/pawelle/mnd-logo-h.webp" alt="Moggies & Doggies Veterinary Care" className="h-16 w-auto rounded-2xl bg-white px-4 py-2 object-contain md:h-20" />
          <div className="flex items-center gap-3">
            {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-pawelle-primary text-white transition-all duration-300 hover:bg-white hover:text-pawelle-primary"
                aria-label="social"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
          <p className="font-body text-[13px] text-white/60">
            Copyright © 2026 Moggies &amp; Doggies Veterinary Care, All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
